<template>
    <div class="pager mt:40 mb:80" v-if="max > 1">
        <div class="
            flex ai:center jc:center gap:0
            {w:40;h:40;inline-flex;ai:center;jc:center;bg:no-repeat;background-position:center|center;color:gray300}>span>a
            {color:gray900}>span.active>a
            {background-color:y300;color:gray900}>span>a:hover
            {background-color:transparent!;color:gray300!}>span:where(.sep,.previous,.next)>a:hover
        ">
            <span class="previous" v-if="page > 1"><a class="bg:url(images/page_prev.svg) bg:url(images/page_prev_hover.svg):hover" :href="`${path}?p=${page - 1}`"></a></span>
            <span class="page" v-if="page > 1"><a :href="`${path}?p=1`">1</a></span>
            <span class="page sep" v-if="page > 4"><a>&hellip;</a></span>
            <span class="page" v-else-if="page > 3"><a :href="`${path}?p=2`">2</a></span>
            <span class="page" v-if="page > 2"><a :href="`${path}?p=${page - 1}`">{{ page - 1 }}</a></span>
            <span class="page active"><a href="javascript:void(0)">{{ page }}</a></span>
            <span class="page" v-if="page + 1 < max"><a :href="`${path}?p=${page + 1}`">{{ page + 1 }}</a></span>
            <span class="page sep" v-if="page + 3 < max"><a>&hellip;</a></span>
            <span class="page" v-else-if="page + 2 < max"><a :href="`${path}?p=${page + 2}`">{{ page + 2 }}</a></span>
            <span class="page" v-if="page < max"><a :href="`${path}?p=${max}`">{{ max }}</a></span>
            <span class="next" v-if="page < max"><a class="bg:url(images/page_next.svg) bg:url(images/page_next_hover.svg):hover" :href="`${path}?p=${page + 1}`"></a></span>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        count: { required: true, type: Number },
        page: { required: true, type: Number },
        path: { required: true, type: String },
        size: { required: true, type: Number }
    });

    const max = Math.ceil(props.count / props.size);
</script>
